import { createContext, useContext } from "react";

export const AuthContext = createContext({
    user: undefined,
    fetchingUser: false,
    reduxUser: undefined,
    setUser: () => {}
});

export const useAuthContext = () => useContext(AuthContext);